/**
 * 当前登录角色（与 {@link api/factory.js} `getCurrentToken` 一致）。
 * 独立模块，避免 `factory ↔ login ↔ api` 循环依赖。
 *
 * @returns {string|null} `ROLES.*` 或 `null`
 */
export default function getCurrentLoginRole() {
  const role = localStorage.getItem('LAST_LOGIN_ROLE');
  const token = localStorage.getItem(`${role}_TOKEN`);
  return role && token ? role : null;
}
